import { Icon } from "@elaniintc/goes-design-system";

interface FiltersSidebarProps {
  label: string;
  active: boolean;
  isUpdated: boolean;
  onSelected: () => void;
}
export default function FiltersSidebar({
  label,
  active,
  isUpdated,
  onSelected,
}: FiltersSidebarProps) {
  return (
    <div className="w-full relative">
      <button
        className="w-full h-16 p-4 gap-4 bg-transparent border-b-[0.5px] border-neutral-silent flex justify-between font-geist text-base leading-3xl font-normal text-body-loud cursor-pointer hover:bg-neutral-object-accent-silent"
        onClick={onSelected}
      >
        <span>{label}</span>
        <div className="flex items-center gap-2">
          {isUpdated && (
            <div className="flex items-center justify-center text-center rounded-full px-1.5 w-6 h-6 bg-surface-action-accent-quiet border border-contextual-action">
              <Icon
                type="far"
                name="check"
                className="text-action-quiet font-normal text-xs leading-xl "
              />
            </div>
          )}
          <Icon
            type="far"
            name="angle-right"
            className="text-current text-sm fill-body-loud py-1 px-2 leading-2xl"
          />
        </div>
      </button>
      {active && (
        <div className="absolute left-0 top-0 h-[38px] w-[5px] bg-surface-action-solid rounded-r-lg translate-y-[11px]"></div>
      )}
    </div>
  );
}
